import * as React from "react";
import {none, option, Option} from "ts-option";
import Modal from "../../ui/modal/Modal";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import FormButtonsView from "../../ui/form/FormButtonsView";
import SerialNumbersData from "../../../model/job/SerialNumbersData";


interface IComponentProps {
	/**
	 * Assets serial numbers
	 */
	serialNumbers: Option<SerialNumbersData>;
	/**
	 * On close callback
	 */
	onClose: () => void;
	/**
	 * On change callback
	 * @param {Option<SerialNumbersData>} serial numbers
	 */
	onChange: (serialNumbers: Option<SerialNumbersData>) => void;
}


interface IState {
	/**
	 * Assets serial numbers tmp values
	 */
	boiler: Option<string>;
	cylinder: Option<string>;
	filter: Option<string>;
	control: Option<string>;
}

type Props = IComponentProps

export default class AssetsSerialNumbersModal extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		if (this.props.serialNumbers.isDefined) {
			const sn = this.props.serialNumbers.get;
			this.state = {
				boiler: sn.boiler,
				cylinder: sn.cylinder,
				filter: sn.filter,
				control: sn.control
			};
		}
		else {
			this.state = {boiler: none, cylinder: none, filter: none, control: none};
		}
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Assets serial numbers"}>
				<Row>
					<Col lg={6} xl={6}>
						<FormGroup label={"Boiler"}>
							<Input type={"text"}
								   onChange={evt => this.setState({boiler: option(evt.target.value)})}
								   value={this.state.boiler.getOrElse("")}/>
						</FormGroup>
					</Col>
					<Col lg={6} xl={6}>
						<FormGroup label={"Cylinder"}>
							<Input type={"text"}
								   onChange={evt => this.setState({cylinder: option(evt.target.value)})}
								   value={this.state.cylinder.getOrElse("")}/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col lg={6} xl={6}>
						<FormGroup label={"Filter"}>
							<Input type={"text"}
								   onChange={evt => this.setState({filter: option(evt.target.value)})}
								   value={this.state.filter.getOrElse("")}/>
						</FormGroup>
					</Col>
					<Col lg={6} xl={6}>
						<FormGroup label={"Control"}>
							<Input type={"text"}
								   onChange={evt => this.setState({control: option(evt.target.value)})}
								   value={this.state.control.getOrElse("")}/>
						</FormGroup>
					</Col>
				</Row>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel"
											onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Change"}
									   onClick={this.onChange}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}

	onChange() {
		if (this.state.boiler.isEmpty && this.state.filter.isEmpty && this.state.control.isEmpty &&
			this.state.cylinder.isEmpty) {
			this.props.onChange(none);
		}
		else {
			this.props.onChange(option(new SerialNumbersData(
				this.state.boiler,
				this.state.cylinder,
				this.state.filter,
				this.state.control))
			)
		}
	}
}